import {FC, ReactElement, useState} from 'react'
import {skipFalsy} from 'shared/lib'
import {GiftFill, GoCoin20, Image, NoteSticky, PlayCircle, Plus} from 'shared/ui/icons'
import styles from './styles.module.scss'

type FeatureItemProps = {
  icon: ReactElement
  value: number
  name: string
}

type FeatureBlockProps = {
  credits: number
  stickers: number
  photos: number
  videos: number
  virtualGifts: number
  displayItemsCount?: number
}

export const FeatureBlock: FC<FeatureBlockProps> = ({
  credits,
  stickers,
  photos,
  videos,
  virtualGifts,
  displayItemsCount
}) => {
  const items: FeatureItemProps[] = skipFalsy(
    credits > 0 ? {icon: <GoCoin20 />, value: credits, name: 'GoCoins'} : null,
    stickers > 0 ? {icon: <NoteSticky />, value: stickers, name: 'Free stickers'}: null,
    photos > 0 ?{icon: <Image />, value: photos, name: 'Free photo'}: null,
    videos > 0 ? {icon: <PlayCircle />, value: videos, name: 'Free video'}: null,
    virtualGifts > 0 ?{icon: <GiftFill />, value: virtualGifts, name: 'Free gifts'}: null
  )

  const [showAll, setShowAll] = useState(false)
  const [hiddenItemsCount, setHiddenItemsCount] = useState(
    items.length - (displayItemsCount || 0)
  )

  const handleShowAll = () => {
    setShowAll(true)
  }

  return (
    <>
      {showAll
        ? items.map((item, index) => <FeatureItem key={index} {...item} />)
        : items
          .slice(0, displayItemsCount)
          .map((item, index) => <FeatureItem key={index} {...item} />)}
      {!showAll && displayItemsCount && displayItemsCount < items.length ?
        <div onClick={handleShowAll} className={styles.btnShow}>
          <div className={styles.btnShowIcon}><Plus /></div>
           and {hiddenItemsCount} benefits
        </div>
        : null}
    </>
  )
}

export const FeatureItem: FC<FeatureItemProps> = ({icon, value, name}) => {
  return (
    <div className={styles.featureItem}>
      <div className={styles.featureItem__icon}>{icon}</div>
      <span className={styles.name}>
        <span className={styles.featureItem__value}>x{value}&nbsp;</span>
        {name}
      </span>
    </div>
  )
}
